<template>
  <van-card class="loyaltyCard" v-for="item in planList" :key="item.id" @click="toDetail(item)" :thumb="item.planImage[0]?.imageUrl">
    <template #title>
      <h2>
        {{ item.loyaltyName }}
      </h2>
      <p class="planTag">{{ item.planTag }}</p>
    </template>
    <template #desc>
      <div>
        购买期限：{{ item.buyStartTime ? addEightHour(item.buyStartTime, 'day', '.') : '' }}-{{
          item.buyEndTime ? addEightHour(item.buyEndTime, 'day', '.') : ''
        }}
      </div>
    </template>
    <template #price>
      <div class="price">厂商建议零售价* ¥{{ item.uniformPrice || 0 }}{{ item.priceTypeFlag === 2 ? '起' : '' }}</div>
    </template>
  </van-card>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { addEightHour } from '@/util'
export default {
  props: ['planList'],
  setup(props) {
    const store = useStore()
    let { planList } = toRefs(props)
    const router = useRouter() //路由
    const state = reactive({
      planList: planList.value
    })
    let toDetail = item => {
      store.dispatch('setLoyalty', item)
      router.push({
        path: '/planDetail',
        query: {
          loyaltyId: item.id,
          from: 'loyaltyList',
          event: '查看致友计划详情'
        }
      })
    }
    return {
      ...toRefs(state),
      toDetail,
      addEightHour
    }
  }
}
</script>
<style lang="scss" scoped>
.van-card {
  color: #666666;
  text-align: left;
  :deep(.van-card__thumb) {
    margin-right: 20px;
    img {
      border-radius: 0;
    }
  }
}
.van-card__content {
  font-size: 12px;
  div {
    margin-top: 4px;
  }
}
h2 {
  font-size: 14px;
  color: #333333;
  font-weight: bold;
}
.price {
  font-size: 14px;
  font-weight: 600;
  color: #3088c5;
}
</style>
